import FetchService from "./Shared/FetchService";
const baseURL = "/aviso/personApplication";
export default class PersonApplicationService {
    static getApplicationStatusesById(ids) {
        return FetchService.get(baseURL + "/getApplicationStatuses", { ids });
    }
    static searchStatuses(query) {
        return FetchService.getSingleResponse(baseURL + "/searchApplicationStatuses", {
            searchText: query,
        });
    }
    static getApplications(affiliationId) {
        return FetchService.get("/aviso/advisor/getApplications", {
            affiliationId,
        });
    }
}
